// extracted by mini-css-extract-plugin
export default {"cardClient":"MediaAttachment_cardClient__YovGl","text":"MediaAttachment_text__-xjGx","checkMark":"MediaAttachment_checkMark__HmlE+","icon":"MediaAttachment_icon__o3zFU"};